<template>
  <div class="skill__content">
    <p>
      Wireframes, prototypes, high-fidelity mockups, interaction decks, design
      systems, and production assets.
    </p>
  </div>
</template>
